module.exports = __webpack_public_path__ + "static/media/sun-small-cloud.c90be8de.png";